import { LogoWhite } from '@aidexa/open-ds';
import Image from 'next/image';
import { FC, ReactNode } from 'react';
import styles from './PartnerMobileHeader.module.scss';

type Props = {
  partnerName: string;
  showPartnerHeader: boolean;
  rightContent?: ReactNode;
};

const PartnerMobileHeader: FC<Props> = ({ partnerName, showPartnerHeader, rightContent }) => {
  if (!showPartnerHeader) return null;

  if (partnerName === 'BNL') {
    return (
      <section className={`${styles.bnlMobileHeader} ${rightContent ? styles.bnlCompactMobileHeader : ''}`}>
        <div className={styles.bnlPartnerMobileLogoWrapper}>
          <Image
            className={styles.bnlLogo}
            src={'/onboarding/dinamico/bnl-header-logo.svg'}
            alt={partnerName}
            width={250}
            height={70}
          />
        </div>
        {rightContent && <div className={styles.bnlHeaderAction}>{rightContent}</div>}
      </section>
    );
  }

  if (partnerName === 'POSTE') {
    return (
      <section className={styles.partnerMobileHeader}>
        <p className={styles.logoDescription}>A cura di</p>
        <div className={styles.partnerMobileLogoWrapper}>
          <LogoWhite />
        </div>
      </section>
    );
  }

  return null;
};

export default PartnerMobileHeader;
